// conectagran/frontend/src/pages/AdManager/index.tsx
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import { GamSetup }     from './GamSetup'
import { GamDashboard } from './GamDashboard'
import { useGamConnection } from '@/api/hooks/useGam'

export function AdManager() {
  const location    = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const oauthError     = searchParams.get('error')

  const { data: conn, isLoading } = useGamConnection()

  // Finance pages for the mapping wizard (ad unit linking)
  const { data: fpData } = useQuery({
    queryKey: ['finance-pages-simple'],
    queryFn: () => (api.get('/finance/pages') as Promise<any[]>).then(pages =>
      pages.map((p: any) => ({ id: String(p.id), name: String(p.name) }))
    ),
  })
  const financePages = fpData ?? []

  // Show dashboard when: already connected + has network_code
  const showDashboard = conn?.connected && conn?.network_code

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0d0f16] flex items-center justify-center text-[#64748b] text-sm">
        Carregando...
      </div>
    )
  }

  if (oauthError) {
    const messages: Record<string, string> = {
      oauth_denied:     'Autorização negada.',
      no_refresh_token: 'Token de atualização não retornado. Tente novamente.',
      invalid_state:    'Estado OAuth inválido. Tente novamente.',
      oauth_failed:     'Erro no OAuth. Tente novamente.',
    }
    return (
      <div className="min-h-screen bg-[#0d0f16] flex flex-col items-center justify-center gap-4">
        <p className="text-[#ef4444] text-sm">{messages[oauthError] ?? 'Erro desconhecido.'}</p>
        <GamSetup financePages={financePages} onComplete={() => window.location.replace('/ad-manager')} />
      </div>
    )
  }

  if (showDashboard) {
    return <GamDashboard />
  }

  return (
    <GamSetup
      financePages={financePages}
      onComplete={() => window.location.replace('/ad-manager')}
    />
  )
}
